import logo from "../assets/ff.png";
import banner from "../assets/foodforest-logo.svg";
import cache, { cacheItems } from "./cache";

const label = {
  "foodforest.app": {
    title: "Food Forest",
    tagline: "A smarter way to grocery",
    darkColor: "#37A76F",
    lightColor: "#99CB38",
    logoUrl: logo,
    bannerUrl: banner
  }
};

let out = label["foodforest.app"];

cache.setItem(cacheItems.FF_LABELING, location.host);

if (cache.getItem(cacheItems.WHITE_LABEL_THEME)) {
  out = cache.getItem(cacheItems.WHITE_LABEL_THEME);
  if (out.darkColor) {
    document.documentElement.style.setProperty(
      "--plt-primary-dark",
      out.darkColor
    );
  }
  if (out.lightColor) {
    document.documentElement.style.setProperty(
      "--plt-primary-light",
      out.lightColor
    );
  }
}

export default out;

//OLD STUFF

// const label = {
//   "localhost:3000": {
//     title: "Food Forest",
//     tagline: "A smarter way to grocery",
//     darkColor: "#37A76F",
//     lightColor: "#99CB38",
//     logoUrl: logo,
//     bannerUrl: banner
//   },
//   "findlaymarket.foodforest.app": {
//     title: "Findlay Market",
//     tagline: "We mean business",
//     darkColor: "#114432",
//     lightColor: "#99cccc",
//     logoUrl: "https://s3.us-east-2.amazonaws.com/ff-large-upc-webp2/fm-logo.png",
//     bannerUrl:
//       "https://s3.us-east-2.amazonaws.com/ff-large-upc-webp2/fm-banner.png"
//   },
//   "foodforest.app": {
//     title: "Food Forest",
//     tagline: "A smarter way to grocery",
//     darkColor: "#37A76F",
//     lightColor: "#99CB38",
//     logoUrl: logo,
//     bannerUrl: banner
//   }
// };

/*eslint no-restricted-globals: [0]*/
// let out = label[location.host];

// if (!out) {
//   /*eslint no-restricted-globals: [0]*/
//   out = label["foodforest.app"];
// }
